import {DomainEvent} from './DomainEvent';

interface ImportBatchInfo {
  readonly bucketName: string;
  readonly objectKey: string;
}

/**
 * This event can be fired to indicate that some data as requested via an export event is
 * available within a S3 bucket and can be processed.
 */
export class ImportBatchUploaded extends DomainEvent<ImportBatchInfo> {}
